import { apiEndPoints, apiMethods } from '../../../../../../utils/apiConstants'
import customAxios from '../../../../../../utils/customAxios'

export const gameProductsListingThunk = async (body) => {
	try {
		const response = await customAxios[apiMethods.post](apiEndPoints.userGameProductsListing, body)
		return { data: response.data }
	} catch (error) {
		throw error
	}
}

export const purchasedGamesThunk = async (gameId) => {
	try {
		const response = await customAxios[apiMethods.get](apiEndPoints.purchasedGames(gameId))
		return { data: response.data }
	} catch (error) {
		throw error
	}
}
